'use strict';

/*global initialize*/

(function ($) {

  function checkCollectionItemControllers($collectionWrapper) {
    $collectionWrapper.find('.collection-item-remove').hide();
    if ($collectionWrapper.find('.collection-item').length > 1) {
      $collectionWrapper.find('.collection-item-remove').show();
    }
  }

  function createCollectionItemControllers($collectionItem, options) {
    var $controllers = $('<div class="collection-item-controllers">');

    var $addButton = $('<a>', { class: 'collection-item-button collection-item-add ' + options.btnClass, title: options.btnAddTitle });
    $addButton.append(options.btnAddContent);
    $controllers.append($addButton);

    if (($.isFunction(options.allowRemove) && options.allowRemove($collectionItem)) || (!$.isFunction(options.allowRemove) && options.allowRemove)) {
      var $removeButton = $('<a>', { class: 'collection-item-button collection-item-remove ' + options.btnClass, title: options.btnRemoveTitle });
      $removeButton.append(options.btnRemoveContent);
      $controllers.append($removeButton);
    }

    $collectionItem.append($controllers);
  }

  function addCollectionItem($collectionItem, options) {
    var $collectionWrapper = $collectionItem.closest('.collection-init');

    var index = $collectionWrapper.data('index');
    var prototypeForm = $collectionWrapper.data('prototype');
    var newForm = prototypeForm.replace(/__name__/g, index);
    var $newCollectionItem = $(newForm);
    $newCollectionItem.insertAfter($collectionItem);
    createCollectionItemControllers($newCollectionItem, options);
    $collectionWrapper.data('index', index + 1);

    initialize($newCollectionItem);

    checkCollectionItemControllers($collectionWrapper);
  }

  function removeCollectionItem($collectionItem) {
    var $collectionWrapper = $collectionItem.closest('.collection-init');
    $collectionItem.remove();

    checkCollectionItemControllers($collectionWrapper);
  }

  var methods = {
    init: function (options) {

      options = $.extend({}, $.fn.k2_formCollection.defaults, options);

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('collection-init')) {
          return;
        }

        $this.data('index', $this.find('.collection-item').length);
        $this.addClass('collection-init');

        $this.find('.collection-item').each(function () {
          createCollectionItemControllers($(this), options);
        });

        checkCollectionItemControllers($this);

        $this.on('click', '.collection-item-add', function () {
          addCollectionItem($(this).closest('.collection-item'), options);
        });

        $this.on('click', '.collection-item-remove', function () {
          removeCollectionItem($(this).closest('.collection-item'));
        });
      });
    }
  };

  $.fn.k2_formCollection = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_formCollection');
    }

  };

  $.fn.k2_formCollection.defaults = {
    allowRemove: true,
    btnAddTitle: '',
    btnRemoveTitle: '',
    btnAddContent: '<span class="glyphicon glyphicon-plus">',
    bntRemoveContent: '<span class="glyphicon glyphicon-remove">',
    btnClass: ''
  };

})(jQuery);
